import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import i18n  from './i18n'
import "./vee-validate";
import router from './router'
import {store} from './store'
import 'url-search-params-polyfill';
import Nl2br from 'vue-nl2br'

Vue.component('nl2br', Nl2br)
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
// don't forget to import CSS styles
import 'tiptap-vuetify/dist/main.css'

import 'vuetify/dist/vuetify.min.css'


Vue.config.productionTip = false

Vue.use(TiptapVuetifyPlugin, {
  // the next line is important! You need to provide the Vuetify Object to this place.
  vuetify, // same as "vuetify: vuetify"
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: 'mdi'
})

new Vue({
  vuetify,
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const l = urlParams.get('lang')




if(!(store.state.lang == "ca" || store.state.lang == "es")){
  i18n.locale = l

}
else if(store.state.lang == "ca" ){
  i18n.locale = 'ca'
}
else{
  i18n.locale = 'es'
}